import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Check, X, Crown, Sparkles, Package } from "lucide-react";
import { ICONS } from "@/components/marketplace/marketplaceIcons";

export function ModuleDetailDialog({ module, plan, subscribing, unsubscribing, onSubscribe, onUnsubscribe, onClose }) {
  if (!module) return null;
  const Icon = ICONS[module.icon] || Package;

  return (
    <Dialog open={!!module} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-3 bg-emerald-100 rounded-xl">
              <Icon className="w-6 h-6 text-emerald-600" />
            </div>
            <div>
              <DialogTitle>{module.name}</DialogTitle>
              <p className="text-sm text-muted-foreground mt-1">{module.description}</p>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div>
            <h4 className="font-semibold text-sm text-gray-700 mb-2">Funcionalidades incluídas:</h4>
            <ul className="space-y-2">
              {module.features?.map((feature, i) => (
                <li key={i} className="flex items-center gap-2 text-sm">
                  <Check className="w-4 h-4 text-emerald-500" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className="p-4 bg-gray-50 rounded-xl">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Preço mensal</span>
              <span className="text-2xl font-bold">€{module.price.toFixed(2)}</span>
            </div>
          </div>

          {module.is_included_in_plan && (
            <div className="p-4 bg-emerald-50 rounded-xl border border-emerald-200">
              <p className="text-sm text-emerald-700 flex items-center gap-2">
                <Crown className="w-4 h-4" />
                Este módulo está incluído no seu plano {plan}
              </p>
            </div>
          )}

          {module.is_trial && (
            <div className="p-4 bg-blue-50 rounded-xl border border-blue-200">
              <p className="text-sm text-blue-700 flex items-center gap-2">
                <Sparkles className="w-4 h-4" />
                Acesso gratuito durante o período trial
              </p>
            </div>
          )}
        </div>

        <DialogFooter>
          {module.is_subscribed ? (
            <div className="flex gap-2 w-full">
              <Button variant="outline" className="flex-1" onClick={onClose}>Fechar</Button>
              <Button variant="destructive" className="flex-1" onClick={() => onUnsubscribe(module.id)} disabled={unsubscribing}>
                {unsubscribing
                  ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Cancelando...</>
                  : <><X className="w-4 h-4 mr-2" /> Cancelar Assinatura</>
                }
              </Button>
            </div>
          ) : !module.is_included_in_plan && !module.is_trial ? (
            <div className="flex gap-2 w-full">
              <Button variant="outline" className="flex-1" onClick={onClose}>Cancelar</Button>
              <Button className="flex-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => onSubscribe(module.id)} disabled={subscribing}>
                {subscribing
                  ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Ativando...</>
                  : <><Check className="w-4 h-4 mr-2" /> Assinar Módulo</>
                }
              </Button>
            </div>
          ) : (
            <Button onClick={onClose} className="w-full">Fechar</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
